import React, { Component } from "react";
import ReactMde from "react-mde";
import ReactMarkdown from 'react-markdown'
import "react-mde/lib/styles/css/react-mde-all.css";

class Others extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customer_project_value: "",
      customer_project: [],
      ot_description: "",
      ot_timestamp: "",
      able: "disabled",
      query: "",
      ot_ID: 0,
      count: 0,
      change: false,
      titleText: "Füge neue andere Events ein",
      previewText: "Preview",
      preview: false,
    };
  }

  componentDidMount() {
    var query = window.location.search;
    if (this.props.token) {
      this.setState({ count: 0 });
    } else {
      this.setState({ count: 1 });
    }

    fetch("/api/customer_project", {
      method: "GET", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
        "x-access-token": this.props.token,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((json) => {
        if (json !== "Token missing or invalid." && json["customer"].length !== 0) {
          this.setState({ customer_project: json["customer"] });
          this.setState({
            customer_project_value: json["customer"][0]["cu_name"],
          });
        }
      });
    if (query) {
      this.setState({ edit_mode: true })
      fetch("/api/others" + query, {
        method: "GET",
        headers: {
          "content-Type": "application/json",
          "x-access-token": this.props.token
        }
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json !== "Token missing or invalid.") {
            this.setState({ customer_project_value: json[0]["cu_name"] })
            this.setState({ ot_timestamp: json[0]["ot_timestamp"] })
            this.setState({ ot_description: json[0]["ot_description"] })
            this.setState({ ot_ID: json[0]["ot_ID"] })
            this.setState({
              change: true,
              titelText: "Ändere dieses andere Event",
            })
          }
        })
    }
  }

  markdownChangeHandler = (e) => {
    this.setState({ ot_description: e });
  };

  onClickPreview = (e) => {
    if (this.state.preview) {
      this.setState({
        previewText: "Preview",
        preview: false
      })
    } else {
      this.setState({
        previewText: "Edit",
        preview: true
      })
    }
  }

  onSubmitEdit = (e) => {
    e.preventDefault();
    let count = 0;
    let ot_timestamp = this.state.ot_timestamp;
    var re = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})$/;
    if (!re.test(ot_timestamp)) {
      this.setState({ count: 6 })
      count = 1
    }

    let body = {
      ot_ID: this.state.ot_ID,
      ot_timestamp: ot_timestamp + ":00.00Z",
      ot_description: this.state.ot_description,
      customer_project: this.state.customer_project_value,
    };
    if (!(count === 1)) {
      this.setState({ count: 3 });
      fetch("/api/others", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": this.props.token,
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json === "OK") {
            this.setState({
              ot_timestamp: "",
              ot_description: "",
              able: "disabled",
              count: 7,
            });
          }
          else if (json === "Every key needs a value") {
            this.setState({ count: 5 });
          }
          else {
            this.setState({ count: 4 });
          }
        });
    }

  }

  onSubmit = (e) => {
    e.preventDefault();
    let count = 0;
    let ot_timestamp = this.state.ot_timestamp;
    var re = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})$/;
    if (!re.test(ot_timestamp)) {
      this.setState({ count: 6 })
      count = 1
    }

    let body = {
      ot_timestamp: ot_timestamp + ":00.00Z",
      ot_description: this.state.ot_description,
      customer_project: this.state.customer_project_value,
    };
    if (!(count === 1)) {
      this.setState({ count: 3 });
      fetch("/api/others", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": this.props.token,
        },
        body: JSON.stringify(body),
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          if (json === "OK") {
            this.setState({
              ot_timestamp: "",
              ot_description: "",
              able: "disabled",
              count: 2,
            });
          }
          else if (json === "Every key needs a value") {
            this.setState({ count: 5 });
          }
          else {
            this.setState({ count: 4 });
          }
        });
    }
  };


  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  render() {
    const {
      customer_project,
      ot_timestamp,
      ot_description,
      customer_project_value,
    } = this.state;
    return (
      <div className="container-lg p-3 my-3">
        <center>
          <h3>
            {this.state.titleText}
          </h3>
        </center>
        <form onSubmit={this.onSubmit}>
          <div className="row mt">
            <div className="col form-group mt-3 ">
              <label>Wähle ein Kundenprojekt*</label>
              <select
                className="form-control form-control"
                name="customer_project_value"
                value={customer_project_value}
                onChange={this.handleChange}
                placeholder="Kunden Wählen*"
                required
              >
                {customer_project.map((customer_project) => (
                  <option key={customer_project["cu_ID"]}>
                    {customer_project["cu_name"]}
                  </option>
                ))}
              </select>
            </div>
            <div className="col mt-3">
              <label>Datum des Anderen Event*</label>
              <input
                className="form-control"
                name="ot_timestamp"
                value={ot_timestamp}
                placeholder="Startzeit*"
                type="datetime-local"
                onChange={this.handleChange}
                min="2021-05-11T07:00"
                required
              ></input>
            </div>
          </div>
          {!this.state.preview && (
            <div className="row mt-3">
              <div className="col">
                <ReactMde
                  name="ot_description"
                  value={ot_description}
                  toolbarCommands={[
                    ["header", "bold", "italic"],
                    ["unordered-list", "ordered-list"],
                  ]}
                  onChange={(e) => this.markdownChangeHandler(e)}
                  disablePreview="true"
                />
              </div>
            </div>
          )}
          {this.state.preview && (
            <div className="row p-3 m-1 mt-3">
              <div className="col">
                <ReactMarkdown>{ot_description}</ReactMarkdown>
              </div>
            </div>
          )}
          {!this.state.change && (
            <div className="row mt-3 m-1 d-flex justify-content-between">
              <button
                className="btn btn-success mt-3"
                type="submit"
              >
                Absenden
              </button>
              <button onClick={this.onClickPreview} type="button" className="btn btn-info mt-3">
                {this.state.previewText}
              </button>
            </div>
          )}
          {this.state.change && (
            <div className="row m-1 mt-3 d-flex justify-content-between">
              <button
                className="btn btn-success"
                onClick={this.onSubmitEdit}
                type="button"
              >
                Ändern
              </button>

              <button onClick={this.onClickPreview} type="button" className="btn btn-info mt-3">
                {this.state.previewText}
              </button>
            </div>
          )}
        </form>
        {this.state.count === 3 && (
          <div className="spinner-border text-secondary mt-2" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        )}
        {this.state.count === 2 && (
          <div className="alert alert-success mt-2" role="alert">
            Erfolgreich hinzugefügt
          </div>
        )}
        {this.state.count === 1 && (
          <div className="alert alert-warning mt-2" role="alert">
            Du bist nicht eingeloggt
          </div>
        )}
        {this.state.count === 4 && (
          <div className="alert alert-warning mt-2" role="alert">
            Kunde nicht Vorhanden
          </div>
        )}
        {this.state.count === 5 && (
          <div className="alert alert-warning mt-2" role="alert">
            Bitte jedes Feld ausfüllen
          </div>
        )}
        {this.state.count === 6 && (
          <div className="alert alert-warning mt-2" role="alert">
            Datum in einem falschen Format (yyyy-mm-ddThh:mm)
          </div>
        )}
        {this.state.count === 7 && (
          <div className="alert alert-success mt-2" role="alert">
            Erfolgreich geändert
          </div>
        )}
      </div>
    );
  }


}

export default Others;
